import { createJobsSearchProvider } from './jobs-provider';
import { candidateSearchProvider } from './candidate-provider';

import type { SearchProvider } from './types';
import type { PreparedJobForLLM } from '../utils';

type BuildSearchProvidersArgs = {
  jobs: PreparedJobForLLM[];
};

export function buildSearchProviders({ jobs }: BuildSearchProvidersArgs): SearchProvider[] {
  return [createJobsSearchProvider({ jobs }), candidateSearchProvider];
}
